import basic from '@com/lang/ja/basic'
import resourceManager from '@com/lang/ja/resourceManager'
import workbench from '@com/lang/ja/workbench'
import locale from './locales/ja.json'
import exportHistory from '@pt/lang/ja/exportHistory'
import whole from '@pt/lang/ja/whole'
import videoProject from '@pt/lang/ja/videoProject'
import assetLibrary from '@pt/lang/ja/assetLibrary'
import taskCenter from '@pt/lang/ja/taskCenter'
import cropperDialog from '@/lang/ja/cropperDialog'
import playableProject from '@pt/lang/ja/playableProject'
import templateLibrary from '@pt/lang/ja/templateLibrary'
import dashboard from '@pt/lang/ja/dashboard'
import home from '@pt/lang/ja/home'
import login from '@pt/lang/ja/login'
import voiceLab from '@pt/lang/ja/voiceLab'

export default {
  basic,
  resourceManager,
  cropperDialog,
  workbench: {
    ...workbench,
  },
  playTurbo: {
    exportHistory,
    videoProject,
    assetLibrary,
    whole,
    taskCenter,
    playableProject,
    templateLibrary,
    dashboard,
    home,
    login,
    voiceLab,
  },
  ...locale,
}
